import { useState } from 'react';
import './App.css';

const BASE = process.env.PUBLIC_URL;

const GALLERY = [
  { file: 'JazminYlCeiba-1-1536x904.jpg',                                        span: 2 },
  { file: 'WhatsApp-Image-2021-06-11-at-22.38.22-1000x500.jpeg',                 span: 1 },
  { file: 'WhatsApp-Image-2021-06-11-at-22.38.28-1000x500.jpeg',                 span: 1 },
  { file: '1975205_1106419472723564_275651535281940505_n-960x500.jpg',            span: 2 },
  { file: 'WhatsApp-Image-2021-06-11-at-22.38.25-6-1000x500.jpeg',               span: 2 },
  { file: 'new-set-studio.jpeg',                                                  span: 1 },
  { file: '12832297_1106432922722219_7104692236097538649_n-960x500.jpg',          span: 1 },
  { file: 'WhatsApp-Image-2021-06-11-at-22.38.29-5-960x668.jpeg',                span: 2 },
  { file: '1916097_1106442879387890_5653056529592506014_n-768x512.jpg',           span: 1 },
  { file: 'WhatsApp-Image-2021-06-11-at-22.38.29-768x513.jpeg',                  span: 1 },
  { file: 'new-set-outdoor.jpeg',                                                 span: 1 },
  { file: 'WhatsApp-Image-2019-09-11-at-13.17.00-768x513.jpeg',                  span: 3 },
  { file: 'new-ine.jpeg',                                                          span: 1 },
  { file: 'new-loreal.jpeg',                                                       span: 2 },
  { file: 'new-night-cast.jpeg',                                                   span: 2 },
  { file: 'new-two-directors.jpeg',                                                span: 1 },
  { file: 'new-three-men.jpeg',                                                    span: 1 },
  { file: 'new-city-set.jpeg',                                                     span: 1 },
  { file: 'new-lake-set.jpeg',                                                     span: 1 },
];

const LOGOS = [
  '1-150x150.png',  '2-150x150.png',  '3-150x150.png',  '4-150x150.png',
  '5-150x150.png',  '6-150x150.png',  '7-150x150.png',  '8-150x150.png',
  '9-150x150.png',  '10-150x150.png', '11-150x150.png', '12-150x150.png',
  '13-150x150.png', '14-150x150.png', '15-150x150.png', '16-150x150.png',
  '17-150x150.png', '18-150x150.png', '19-150x150.png', '20-150x150.png',
  '21-150x150.png', '22-150x150.png', '23-150x150.png',
  'ine-1-150x150.png', 'loreal-1-150x150.png', 'unicef-1-150x150.png',
];

function App() {
  const [form, setForm] = useState({ email: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent('Contacto — Máquina Negra');
    const body = encodeURIComponent(`De: ${form.email}\n\n${form.message}`);
    window.location.href = `mailto:eduardo@maquinanegra.com?subject=${subject}&body=${body}`;
    setSent(true);
  };

  return (
    <div className="site" id="top">

      {/* ── Header ── */}
      <header className="site-header">
        <a href="#top" aria-label="Inicio">
          <img
            src={`${process.env.PUBLIC_URL}/logoMaquina.jpg`}
            alt="Máquina Negra"
            className="header-logo"
          />
        </a>
        <nav className="site-nav">
          <a href="#reels">Reels</a>
          <a href="#quienes-somos">Quiénes somos</a>
          <a href="#lo-que-hacemos">Qué hacemos</a>
          <a href="#clientes">Clientes</a>
          <a href="#contact">Contacto</a>
        </nav>
      </header>

      {/* ── Hero ── */}
      <section className="hero">
        <div className="hero-video-wrap">
          <iframe
            src="https://player.vimeo.com/video/380370721?background=1&autoplay=1&loop=1&byline=0&title=0&dnt=1"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title="Máquina Negra — Demo Reel"
          />
        </div>
        <div className="hero-overlay">
          <a href="#reels" className="scroll-hint" aria-label="Ver más">
            <span className="scroll-arrow" />
          </a>
        </div>
      </section>

      {/* ── Reels ── */}
      <section className="reels" id="reels">
        <div className="reel">
          <div className="reel-frame">
            <iframe
              src="https://player.vimeo.com/video/276502319?color=ffffff&title=0&byline=0&portrait=0&dnt=1"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title="Beto Viveros — Reel"
            />
          </div>
          <p className="reel-label">BETO VIVEROS</p>
        </div>
        <div className="reel">
          <div className="reel-frame">
            <iframe
              src="https://player.vimeo.com/video/471060141?color=ffffff&title=0&byline=0&portrait=0&dnt=1"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title="Eduardo Quiroz — Reel"
            />
          </div>
          <p className="reel-label">EDUARDO QUIROZ</p>
        </div>
      </section>

      {/* ── Tagline ── */}
      <section className="tagline-section">
        <p className="tagline">
          Un taller de <em>ideas</em> regenerativas.
        </p>
        <p className="body-text">
          30 años contando historias de cine, TV y redes que enaltecen el valor humano.
          Estrategia, producción y narrativas 360 hechas a la medida.
        </p>
      </section>

      {/* ── Quiénes somos ── */}
      <section className="about" id="quienes-somos">
        <h2 className="section-label">QUIÉNES SOMOS</h2>
        <h3 className="section-heading">Maestros artesanos de la idea.</h3>
        <p className="body-text">
          Somos un taller donde cada pieza es una obra hecha a la medida. Combinamos producción
          audiovisual con estrategia digital para crear comunicación lógica, sensible y real.
        </p>
        <p className="body-text">
          Contamos con un equipo de profesionales con capacidad probada y amplia experiencia
          en producciones de carácter socioambiental.
        </p>
      </section>

      {/* ── Lo que hacemos ── */}
      <section className="services" id="lo-que-hacemos">
        <h2 className="section-label">LO QUE HACEMOS</h2>
        <h3 className="section-heading">Dos disciplinas, una visión.</h3>
        <p className="body-text">
          De la idea al estreno: producción audiovisual integral y estrategias de comunicación 360.
        </p>
        <div className="services-grid">
          <div className="service-col">
            <h4 className="service-title">🎬 Producción audiovisual</h4>
            <ul>
              <li>Producción de cine y TV</li>
              <li>Post producción</li>
              <li>Animación 2D y 3D</li>
              <li>Contenido digital</li>
              <li>Fotografía</li>
              <li>Círculo dorado</li>
            </ul>
          </div>
          <div className="service-col">
            <h4 className="service-title">📡 Comunicación y agencia</h4>
            <ul>
              <li>Estrategias de comunicación</li>
              <li>Campañas ATL y BTL</li>
              <li>Diseño gráfico</li>
              <li>Social Media</li>
              <li>Relaciones públicas</li>
              <li>Comunicación social</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ── Galería ── */}
      <section className="gallery">
        <div className="gallery-grid">
          {GALLERY.map(({ file, span }) => (
            <div
              key={file}
              className="gallery-item"
              style={{ gridColumn: `span ${span}` }}
            >
              <img
                src={`${BASE}/Images_Web_MAquina/${file}`}
                alt=""
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </section>

      {/* ── Con quiénes hemos trabajado ── */}
      <section className="clients" id="clientes">
        <div className="clients-header">
          <h2 className="section-label">CON QUIÉNES HEMOS TRABAJADO</h2>
        </div>
        <div className="logos-rows">
          {[
            { logos: LOGOS.slice(0, 9),  duration: '30s', reverse: false },
            { logos: LOGOS.slice(9, 18), duration: '45s', reverse: true  },
            { logos: LOGOS.slice(18),    duration: '24s', reverse: false  },
          ].map(({ logos, duration, reverse }, i) => (
            <div className="logos-wrap" key={i}>
              <div
                className={`logos-track${reverse ? ' logos-track--reverse' : ''}`}
                style={{ animationDuration: duration }}
              >
                {[...logos, ...logos].map((file, j) => (
                  <img
                    key={j}
                    src={`${BASE}/LOGOS_web_Maquina/${file}`}
                    alt=""
                    className="client-logo"
                    loading="lazy"
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Contacto ── */}
      <section className="contact" id="contact">
        <h2 className="section-label">CONTACTO</h2>
        <h3 className="section-heading">¿Tienes una historia que contar?</h3>
        <p className="body-text">
          Escríbenos. Cada proyecto empieza con una conversación.
        </p>
        {sent ? (
          <p className="form-success">
            Gracias. Nos pondremos en contacto pronto.
          </p>
        ) : (
          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              type="email"
              name="email"
              placeholder="Correo electrónico"
              value={form.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Mensaje"
              value={form.message}
              onChange={handleChange}
              required
              rows={5}
            />
            <button type="submit">Enviar</button>
          </form>
        )}
      </section>

      <footer className="footer">
        <p>© {new Date().getFullYear()} Máquina Negra. Todos los derechos reservados.</p>
      </footer>

    </div>
  );
}

export default App;
